<ui-input-select-wrapper [open]="open()" [theme]="theme()" (openChange)="open.set($event)">
    <ui-input-wrapper
        [value]="selectedLabel()?.label"
        [placeholder]="placeholder()"
        [disabled]="disabled()"
        [label]="label()"
        [error]="error()"
        [errorMsg]="errorMsg()"
        [theme]="theme()"
        [focussed]="open()"
        (clicked)="!disabled() ? openSelect() : open.set(false)"
    >
        <i
            class="icon-chevron-down text-accent transition-transform"
            [ngClass]="{
                'rotate-180': open(),
                'text-accent': theme() === 'light' || theme() === 'dark',
                'text-white': theme() === 'medium',
                'opacity-50': disabled(),
            }"
            trailing
        ></i>
    </ui-input-wrapper>

    <div class="flex w-full flex-col" dropdown>
        @if (withNullSelect()) {
            <button
                class="flex items-center px-16 py-12 text-left transition-colors"
                [ngClass]="{ 'hover:bg-grey-200': theme() === 'light', 'hover:bg-blue': theme() === 'dark' }"
                (click)="setValue(undefined)"
            >
                {{ nullSelectCustomLabel() }}
            </button>
        }

        @for (option of options(); let i = $index; track i) {
            <button
                class="0 flex items-center px-16 py-12 text-left transition-colors"
                [ngClass]="{ 'hover:bg-grey-200': theme() === 'light', 'hover:bg-blue': theme() === 'dark' }"
                [innerHTML]="option.label"
                (click)="setValue(option.value)"
            ></button>
        }
    </div>
</ui-input-select-wrapper>
